"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbUSDSession = void 0;
const events_1 = require("../../../security/events");
const cc_1 = require("../cc");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
class MbUSDSession extends cc_1.MbCCSession {
    constructor() {
        super(...arguments);
        this.isDataValid = (data) => {
            if (data.entrypoint === cc_1.EntrypointType.USD && data.accessToken && data.agentToken) {
                return true;
            }
            return false;
        };
        this.getHeaders = () => {
            const data = this.getData();
            return {
                accessToken: data?.agentToken ?? '',
            };
        };
        this.doRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const actualSessionInfo = {
                    refreshToken: this.getData()?.refreshToken,
                    username: this.getData()?.username,
                };
                const headers = this.getHeaders();
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/refresh-token`, actualSessionInfo, { headers });
                const newSessionData = {
                    ...this.getData(),
                    accessToken,
                    sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                    expiresIn,
                    refreshToken: refreshToken ?? actualSessionInfo.refreshToken,
                    username: this.getData()?.username ?? '',
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
        this.doAgentRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const agentToken = await this.usd?.getMethods().getAgentAccessToken();
                const newSessionData = {
                    ...this.getData(),
                    agentToken: agentToken,
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
    }
}
exports.MbUSDSession = MbUSDSession;
//# sourceMappingURL=index.js.map